import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import { FormTitle } from '@commonComponents/FormTitle'
import { ContainerForm } from '@EUForms/containerForm'
import { useSelector } from 'react-redux'

const Containers = ({ merchandiseId, addItem, deleteItem, isMerchandiseDisabled }) => {
  const containers =
    useSelector(
      (state) => state.invoiceReducer.invoice.merchandiseMap[merchandiseId]?.containersList
    ) || []
  console.log({ containers })
  const headerContainers = useSelector((state) => state.containerReducer.containersList)
  const computeContainerDopdownMerchendise = useCallback(() => {
    var filteredContainers = headerContainers?.filter(
      (elem) => !containers.find(({ containerNumber }) => elem.containerNumber === containerNumber)
    )
    return filteredContainers
  }, [containers?.length, headerContainers?.length])

  var containerList = computeContainerDopdownMerchendise() || []
  // console.log({containerList});
  return (
    <Grid className='responsiveGridCss'>
      <FormTitle title='CONTAINERS' containerStyle={{ width: '100%' }} />
      <ContainerForm
        containers={containers}
        deleteContainer={deleteItem}
        addContainer={addItem}
        containerList={containerList}
        isMerchandiseDisabled={isMerchandiseDisabled}
      />
    </Grid>
  )
}

export default React.memo(Containers)
